// extracted by mini-css-extract-plugin
module.exports = {"checkbox":"Permissions_checkbox__WrrS_","checkboxGroup":"Permissions_checkboxGroup__2A-fT"};